/*
 * gg-sticky-atc.js — Gummy Gardens sticky add-to-cart bar (A-06, 2026-09-24).
 *
 * A fixed bottom bar (title · displayed price · Add to cart) that shows whenever the real buy button is NOT in the
 * viewport (above or below it, including at first view on a phone), and hides while the button is visible or the
 * cart drawer is open (2026-10-12, founder: friction fix; was "only after it scrolled out above"). Its button simply
 * clicks the theme's own submit button, so the theme's product-form (and Recharge's selling-plan input) does all
 * the work. READ-ONLY towards the price: the bar copies the text of the theme's light-DOM price element
 * (.price inside product-info, including the gg-header-price saving span). It never reads or writes inside the
 * Recharge widget's shadow DOM.
 */
(function () {
  'use strict';

  var bar, titleEl, priceEl, btn, submit, priceHost, drawer;
  var passed = false, drawerOpen = false, mounted = false;

  function findSubmit() {
    return document.querySelector('product-info form[action*="/cart/add"] button[name="add"], product-info .product-form__submit, form[action*="/cart/add"] button[name="add"], .product-form__submit');
  }
  function findPriceHost() {
    return document.querySelector('product-info .price, .product__info-container .price, .product .price');
  }
  function findTitle() {
    var n = document.querySelector('[data-gg-product-name]');
    if (n && n.getAttribute('data-gg-product-name')) return n.getAttribute('data-gg-product-name');
    var h = document.querySelector('product-info .product__title h1, .product__title h1, .product__info-container h1');
    return h ? h.textContent.replace(/\s+/g, ' ').trim() : document.title;
  }
  function visible(el) {
    if (!el) return false;
    var r = el.getClientRects();
    if (!r.length) return false;
    var s = window.getComputedStyle(el);
    return s.visibility !== 'hidden' && s.display !== 'none';
  }
  function hiddenByA11y(el) {
    while (el && el !== priceHost) { if (el.classList && el.classList.contains('visually-hidden')) return true; el = el.parentElement; }
    return false;
  }
  /** Displayed price text from the theme's own price element (light DOM only). */
  function priceText() {
    if (!priceHost || !priceHost.isConnected) priceHost = findPriceHost();
    if (!priceHost) return '';
    var parts = [], nodes = priceHost.querySelectorAll('.price-item, .gg-hdr-saving');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (!visible(n) || hiddenByA11y(n)) continue;
      var t = n.textContent.replace(/\s+/g, ' ').trim();
      if (!t) continue;
      var struck = n.tagName === 'S' || !!n.closest('s');
      try { if (!struck && /line-through/.test(getComputedStyle(n).textDecorationLine || getComputedStyle(n).textDecoration || '')) struck = true; } catch (e) {}
      parts.push(struck ? '<s>' + t + '</s>' : t);
    }
    // founder 2026-10-11: the list price must read crossed out whenever a lower price follows it (e.g. "$40.00 $36 (Save $4)").
    var money = function (x) { var m = String(x).replace(/<\/?s>/g, '').match(/\$\s?([\d,]+(?:\.\d+)?)/); return m ? parseFloat(m[1].replace(/,/g, '')) : null; };
    for (var k = 0; k + 1 < parts.length; k++) {
      var a = money(parts[k]), b = money(parts[k + 1]);
      if (a != null && b != null && b < a && !/^<s>/.test(parts[k]) && !/save/i.test(parts[k])) parts[k] = '<s>' + parts[k] + '</s>';
    }
    if (!parts.length) parts.push(priceHost.textContent.replace(/\s+/g, ' ').trim());
    // founder 2026-10-11: bold the price the customer pays (the first un-struck dollar amount that is not the saving).
    for (var q = 0; q < parts.length; q++) {
      if (/^<s>/.test(parts[q]) || money(parts[q]) == null) continue;
      // the paying price may share a node with "(Save $4)": bold only the leading amount, never the saving
      var m2 = parts[q].match(/^([^$]*)(\$\s?[\d,]+(?:\.\d+)?)/);
      if (m2 && !/save/i.test(m2[1])) { parts[q] = m2[1] + '<b>' + m2[2] + '</b>' + parts[q].slice(m2[0].length); break; }
    }
    var out = [], seen = {};
    for (var j = 0; j < parts.length; j++) { if (!seen[parts[j]]) { seen[parts[j]] = 1; out.push(parts[j]); } }
    // founder 2026-10-12: sticky bar reads "(Save $N)" with a capital S
    return out.join(' ').replace(/\s*\(/g, ' (').replace(/\(\s*/g, '(').replace(/\s+/g, ' ').trim().replace(/\(save /gi, '(Save ');
  }
  function escapeHtml(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function renderPrice() {
    var t = priceText();
    var html = escapeHtml(t).replace(/&lt;(\/?)(s|b)&gt;/g, '<$1$2>');
    if (priceEl.innerHTML !== html) priceEl.innerHTML = html;
  }
  function syncButton() {
    if (!submit || !submit.isConnected) submit = findSubmit();
    if (!submit) return;
    var disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
    btn.disabled = disabled;
    var label = (submit.querySelector('span') || submit).textContent.replace(/\s+/g, ' ').trim();
    if (label && btn.textContent !== label) btn.textContent = label;
  }
  function update() {
    if (!bar) return;
    var show = passed && !drawerOpen && !!submit;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
  function mount() {
    if (mounted) return; mounted = true;
    submit = findSubmit();
    if (!submit) return;
    priceHost = findPriceHost();

    bar = document.createElement('div');
    bar.className = 'gg-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');
    var info = document.createElement('div'); info.className = 'gg-sticky-atc__info';
    titleEl = document.createElement('div'); titleEl.className = 'gg-sticky-atc__title'; titleEl.textContent = findTitle();
    priceEl = document.createElement('div'); priceEl.className = 'gg-sticky-atc__price';
    info.appendChild(titleEl); info.appendChild(priceEl);
    btn = document.createElement('button'); btn.type = 'button'; btn.className = 'gg-sticky-atc__btn'; btn.textContent = 'Add to cart';
    btn.addEventListener('click', function () {
      if (!submit || !submit.isConnected) submit = findSubmit();
      if (!submit || submit.disabled) return;
      submit.click();
    });
    bar.appendChild(info); bar.appendChild(btn);
    document.body.appendChild(bar);

    renderPrice(); syncButton();

    // Show whenever the real button is out of the viewport (above or below). IntersectionObserver, with a
    // scroll/resize fallback for old browsers and for re-rendered buttons.
    var io = null, observed = null;
    function measure() {
      if (!submit || !submit.isConnected) submit = findSubmit();
      if (!submit) { passed = false; update(); return; }
      if (observed !== submit) {
        if (io) io.disconnect();
        observed = submit;
        if ('IntersectionObserver' in window) {
          io = new IntersectionObserver(function (entries) {
            var e = entries[entries.length - 1];
            passed = !e.isIntersecting;
            update();
          }, { threshold: 0 });
          io.observe(submit);
        }
      }
      if (!io) {
        var r = submit.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        passed = !r.height || r.bottom < 0 || r.top > vh;
        update();
      }
    }
    var ticking = false;
    function onScroll() { if (!ticking) { ticking = true; setTimeout(function () { ticking = false; measure(); }, 120); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    measure();

    // Hide while the cart drawer is open (Dawn toggles `active` on <cart-drawer>).
    drawer = document.querySelector('cart-drawer');
    function readDrawer() {
      drawerOpen = !!(drawer && drawer.classList.contains('active')) || document.body.classList.contains('overflow-hidden');
      update();
    }
    if (drawer) new MutationObserver(readDrawer).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(readDrawer).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    readDrawer();

    // Follow the displayed price (variant changes re-render the theme price; gg-header-price appends its span).
    var pending = null;
    function schedule() { clearTimeout(pending); pending = setTimeout(function () { renderPrice(); syncButton(); measure(); }, 150); }
    var host = document.querySelector('product-info') || document.querySelector('.product__info-container') || document.body;
    new MutationObserver(schedule).observe(host, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
    [800, 2000, 4000].forEach(function (ms) { setTimeout(schedule, ms); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();

  // founder 2026-10-11: tag the Klaviyo popup's main CTA (not "No, thanks") so CSS can give it the flavour colour.
  (function () {
    function tag() {
      var bs = document.querySelectorAll('form[data-testid="klaviyo-form-UjjKC6"] .klaviyo-form-button');
      for (var i = 0; i < bs.length; i++) {
        var t = (bs[i].innerText || bs[i].textContent || '').trim();
        if (/no,?\s*thanks/i.test(t)) bs[i].classList.add('gg-kl-dismiss'); else bs[i].classList.add('gg-kl-cta');
      }
    }
    try { new MutationObserver(tag).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    tag();
  })();
})();
